import { Box, Flex, Text } from '@mantine/core';
import { IconFileText, IconFileTextSpark, IconFolder } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  fileName: string;
  fileSize?: number;
  isFolder: boolean;
  isGenerated: boolean;
};

export default function FileNameWithIcon({ fileName, fileSize, isFolder, isGenerated }: Props) {
  const Icon = getIcon(isFolder, isGenerated);
  return (
    <Flex wrap={'nowrap'} gap={'xs'} align="center">
      <Flex bg="gray.1" w={40} h={40} align="center" justify="center" style={{ borderRadius: 20 }}>
        {<Icon size={20} />}
      </Flex>
      <Box>
        <Text fw={FONT_WEIGHTS.medium} size="textSm" c="gray.10">
          {fileName}
        </Text>
        {fileSize != null && (
          <Text fw={500} size="sm" c="gray.7">
            {humanFileSize(fileSize)}
          </Text>
        )}
      </Box>
    </Flex>
  );
}

function humanFileSize(size: number | null | undefined) {
  if (!size) {
    return '';
  }
  const i = size == 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
  return +(size / Math.pow(1024, i)).toFixed(2) + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

const icons = {
  folder: IconFolder,
  file: IconFileText,
  generated: IconFileTextSpark,
};
function getIcon(isFolder: boolean, isGenerated: boolean) {
  if (isFolder) {
    return icons.folder;
  }
  if (isGenerated) {
    return icons.generated;
  }
  return icons.file;
}
